import styled from '@emotion/styled';
import React, { useEffect, useState } from 'react';
import { useAppSelector } from 'store/config';

import Klaytn from 'klaytn/Klaytn';
import BlockNumberItem from './BockNumberItem';

type Props = {};

const BlockNumber = (props: Props) => {
  const mintStartBlockNumber = useAppSelector(
    (state) => state.contract.salesInfo.mintStartBlockNumber,
  );

  const [currentBlockNumber, setCurrentBlockNumber] = useState(0);

  useEffect(() => {
    const getBlockNumberInterval = setInterval(async () => {
      const blockNumber = await Klaytn.getBlockNumber();
      setCurrentBlockNumber(blockNumber);
    }, 1000);

    return () => {
      clearInterval(getBlockNumberInterval);
    };
  }, []);

  return (
    <BlockNumberWrapper>
      <BlockNumberItem title='현재 블록 높이' value={currentBlockNumber} />
      <BlockNumberItem title='민팅 블록 높이' value={mintStartBlockNumber} />
    </BlockNumberWrapper>
  );
};

const BlockNumberWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 16px;
  gap: 8px;
`;

export default BlockNumber;
